import colors from '../../colors';

const common = {
  borderColor: colors.primary.ltGrey1,
};

export default common;
